import script from "./SimpleCalculatorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleCalculatorPage.vue?vue&type=script&setup=true&lang=js"

import "./SimpleCalculatorPage.vue?vue&type=style&index=0&id=503f4537&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503f4537"]])

export default __exports__